export default function SFMyFilledIcon({}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11.5" cy="10.5" r="8.5" fill="#A19BFD" />
      <path
        d="M11.5 18C8.73392 18 6.22447 18.9675 4.3843 20.5391C3.7554 21.0762 4.18931 22 5.01636 22H17.9836C18.8107 22 19.2446 21.0762 18.6157 20.5391C16.7755 18.9675 14.2661 18 11.5 18Z"
        fill="#A19BFD"
      />
      <path d="M9 9V11" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M14 9V11" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
